import React, { useState } from 'react';
import classNames from 'classnames';
import styles from './tabs.module.scss';

const Tabs = ({ items, defaultActive, direction, children, className }) => {
  const [ active, setActive ] = useState( defaultActive )

  return (
    <div className={ classNames( styles.tabs, {
      [ styles.vertical ]: direction === 'vertical',
      [ styles.horizontal ]: direction === 'horizontal',
    }, className ) }>
      <div className={ styles.nav }>
        { !! items.length && items.map( item => (
          <button
            key={ item.key }
            type="button"
            className={ classNames( styles.item, {
              [ styles.active ]: item.key === active
            })}
            onClick={ () => setActive( item.key ) }
          >
            <span className={ styles.itemLabel }>{ item.label }</span>
            <span className={ styles.itemLine } />
          </button>
        ))}
      </div>

      <div className={ styles.content }>
        { children && children.map( child => child.props.tabKey === active && child ) }
      </div>
    </div>
  )
}

export default Tabs
